// extracted by mini-css-extract-plugin
export default {"link":"linkified-text_link__tAs9w"};